import Store from 'core/stores/Store.js';
import {makeObservable, observable} from 'mobx';
import autobind from 'common/decorators/autobind.js';
import {GrowthBook} from '@growthbook/growthbook';

export default class GrowthBookStore extends Store {
    constructor(rootStore) {
        super();
        this.rootStore = rootStore;
        makeObservable(this, {
            growthBookInstance: observable,
            isLoaded: observable,
            experimentInfo: observable,
        });
    }

    growthBookInstance = null;
    isLoaded = false;
    experimentInfo = [];

    @autobind
    async init(attributes) {
        try {
            const growthbook = await new GrowthBook({
                apiHost: process.env.REACT_APP_GROWTHBOOK_APIHOST,
                clientKey: process.env.REACT_APP_GROWTHBOOK_CLIENTKEY,
                enableDevMode: true,
                trackingCallback: (experiment, result) => {
                    this.updateStore({
                        experimentInfo: [
                            ...this.experimentInfo,
                            {
                                experiment_id: experiment.key,
                                result: result.key,
                            },
                        ],
                    });
                },
            });

            await growthbook.loadFeatures({autoRefresh: true});

            growthbook.setAttributes({
                ...attributes,
            });

            if (growthbook) {
                this.updateStore({
                    growthBookInstance: growthbook,
                    isLoaded: true,
                });
            }
        } catch (error) {
            throw new Error('Error initializing GrowthBook');
        }
    }
}
